import $ from 'jquery';
import moment from 'moment';
import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import PreplanificationSelection, {
  DATE_FORMAT,
} from 'common/components/PreplanificationSelection';
import Modal from 'common/components/Modal';
import cx from 'classnames';

export default function index() {
  const $button = $('#bt-pre-schedule');
  const $input = $button
    .closest('.field')
    .find('input[name="preplannificationDate"]');
  const $display = $button.closest('.field').find('input[type="text"]');

  const root = document.getElementById('pre-schedule-root');

  const onModalClosed = () => ReactDOM.unmountComponentAtNode(root);

  const onSelectionSaved = selection => {
    onModalClosed();

    $input.val(selection.date).trigger('change');
  };

  $button.on('click', evt => {
    evt.preventDefault();

    const value = $input.val();
    // Rendering scheduling modal
    ReactDOM.render(
      <SchedulingModal
        value={value}
        onSaved={onSelectionSaved}
        onClosed={onModalClosed}
        noDelete={true}
      />,
      root
    );
  });

  // Handling input changes to reformat displayed value
  $input.on('change', evt => {
    const value = evt.target.value;
    if (value && value.length) {
      const date = moment(value, DATE_FORMAT).weekday(0);
      const week = date.isoWeek();

      const formatted = `Semaine ${week} à Partir du ${date.format(
        DATE_FORMAT
      )}`;
      $display.val(formatted);
    }
  });
}

class SchedulingModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      canSubmit: props.value && props.value.length > 0,
    };

    this._onDateSelected = this._onDateSelected.bind(this);
  }

  _onDateSelected(date) {
    this.setState({
      selected: date,
      canSubmit: true,
    });
  }

  render() {
    const { value, onClosed, onSaved, noDelete } = this.props;
    const { selected, canSubmit } = this.state;

    const save = () => onSaved(selected);

    const saveButtonClass = cx('ui primary labeled icon button', {
      disabled: !canSubmit,
    });

    return (
      <Modal isOpened closable onClose={onClosed}>
        <div className="header">Pré Planification</div>
        <div className="content">
          <PreplanificationSelection
            value={value}
            multiSelection={false}
            onSelectionChanged={this._onDateSelected}
            noDelete={noDelete}
          />
        </div>
        <div className="actions">
          <button className={saveButtonClass} onClick={save}>
            <i className="icon save" />
            Enregistrer
          </button>
        </div>
      </Modal>
    );
  }
}

SchedulingModal.propTypes = {
  value: PropTypes.string,
  onSaved: PropTypes.func.isRequired,
  onClosed: PropTypes.func.isRequired,
  noDelete: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/schedule/index.js